import React from 'react';
import { Box, Button } from '@mui/material';

/**
 * Discovery-specific action pill — Buy & Sell only.
 * No Delete, no Chart, no Market Depth.
 * Shown on hover over any stock row in Stock Discovery widgets.
 */
const DiscoveryActions = ({ instrument, onBuy, onSell, userSettings }) => {
  const tradable = instrument?.tradable !== false;

  return (
    <Box
      onClick={(e) => e.stopPropagation()}
      sx={{
        position: 'absolute',
        right: 8,
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'flex',
        gap: 0.5,
        backgroundColor: 'background.paper',
        borderRadius: '20px',
        boxShadow: '0 3px 10px rgba(0,0,0,0.08)',
        padding: '5px 8px',
        zIndex: 10,
        pointerEvents: 'auto',
        transition: 'opacity 0.15s ease-in-out',
        '&:hover': {
          boxShadow: '0 6px 15px rgba(0,0,0,0.12)',
        },
      }}
    >
      <Button
        size="small"
        variant="contained"
        disabled={!tradable}
        onClick={(e) => {
          e.stopPropagation();
          onBuy(instrument, e, userSettings);
        }}
        sx={{
          backgroundColor: !tradable ? 'text.disabled' : 'success.main',
          '&:hover': {
            backgroundColor: !tradable ? 'text.disabled' : 'success.dark',
            transform: !tradable ? 'none' : 'translateY(-1px)',
            boxShadow: !tradable ? 'none' : '0 2px 5px rgba(0,0,0,0.2)',
          },
          minWidth: '52px',
          height: '26px',
          fontSize: '0.78rem',
          fontWeight: 700,
          borderRadius: '13px',
          transition: 'all 0.2s ease',
          textTransform: 'none',
          pointerEvents: !tradable ? 'none' : 'auto',
        }}
      >
        Buy
      </Button>

      <Button
        size="small"
        variant="contained"
        disabled={!tradable}
        onClick={(e) => {
          e.stopPropagation();
          onSell(instrument, e, userSettings);
        }}
        sx={{
          backgroundColor: !tradable ? 'text.disabled' : 'error.main',
          '&:hover': {
            backgroundColor: !tradable ? 'text.disabled' : 'error.dark',
            transform: !tradable ? 'none' : 'translateY(-1px)',
            boxShadow: !tradable ? 'none' : '0 2px 5px rgba(0,0,0,0.2)',
          },
          minWidth: '52px',
          height: '26px',
          fontSize: '0.78rem',
          fontWeight: 700,
          borderRadius: '13px',
          transition: 'all 0.2s ease',
          textTransform: 'none',
          pointerEvents: !tradable ? 'none' : 'auto',
        }}
      >
        Sell
      </Button>
    </Box>
  );
};

export default DiscoveryActions;
